import { Fleet } from './Fleet';

export type Role = 'ADMIN' | 'MANAGER';

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export type User = {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: Role;
  hasTmpPassword?: boolean;
  fleetId: string;
  fleet: Fleet;
  isPhoneNumberConfirmed?: boolean;
  has2FA?: boolean;
  phoneNumber?: PhoneNumber;
  isAdmin: boolean;
  hasVerifiedEmail?: boolean;
};

export const USER_ROLE: Record<string, Role> = {
  ADMIN: 'ADMIN',
  STANDARD: 'MANAGER',
};

export type PhoneNumber = {
  refferenceNumber: string;
  number: string;
};
